export default __webpack_public_path__ + "static/media/logo-01.cf7bf1ed.png";